import React from 'react';
import QureHeader from './QureHeader';

const QureLayout = ({ children }) => {
  return (
    <div className="qure-shell min-h-screen bg-slate-50 font-sans text-slate-800">
      <QureHeader />
      <main className="min-h-[calc(100vh-64px)] bg-gradient-to-b from-[#f0fdfa] to-slate-50 pt-shellHeaderQure transition-[padding] lg:pl-qureSidebar">
        {children}
      </main>
    </div>
  );
};

export default QureLayout;
